// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"register_wrapper__29oUW","link":"register_link__2XLtm"};